import '@chancenwerk/client/components/chancen-component-card-title.js';
import { CrPage } from '@chancenwerk/client/design/components/cr-page.js';
import { ChancenPermission } from '@chancenwerk/shared/permissions.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../components/akademie-component-workshop-entry.js';
import '../components/akademie-component-workshop-migration-onboarding.js';
import '../components/akademie-component-workshop-migration.js';
import '../components/akademie-component-workshop-rag-by-state.js';
import '../components/akademie-component-workshop-rag-by-workshop.js';
import { AkademieDialogWorkshopEdit } from '../components/dialogs/akademie-dialog-workshop-edit.js';

/**
 * @customElement akademie-page-workshops-reporting
 */
@customElement('akademie-page-workshops-reporting')
export class RaumPageWorkshops extends CrPage {
  constructor() {
    super();

    this.label = 'Workshop Reporting';
    this.description = 'Statistiken über Workshops';
    this.permission = ChancenPermission.akademie.EDIT_WORKSHOP;
  }

  override header() {
    return html`<cr-button @click=${() => AkademieDialogWorkshopEdit.showPopup()}>Erstellen</cr-button>`;
  }

  override content() {
    return html` <cr-grid columns="1fr" space="md" padding="sm">
      <akademie-component-workshop-rag-by-workshop></akademie-component-workshop-rag-by-workshop>
      <akademie-component-workshop-rag-by-state></akademie-component-workshop-rag-by-state>
    </cr-grid>`;
  }
}
